import React, { useCallback } from 'react';
import { DatePicker, Input } from '@osui/ui';
import ActionButton from '@baidu/icloud-ui-action-button';
import StateTag from '@baidu/icloud-ui-state-tag';
import { useDerivedState } from 'huse';
import GroupInput from '@baidu/icloud-ui-group-input';
import Text from '@baidu/icloud-ui-text';
import moment from 'moment';
import DateTime from '@baidu/icloud-ui-date-time';
import Select from './Select';
import CustomerColumns from './CustomerColumns';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  RangePicker
} = DatePicker;

const Search = ({
  value,
  ...props
}) => {
  const [v, setV] = useDerivedState(value);
  const handleChange = useCallback(e => setV(e.target.value), [setV]);
  return /*#__PURE__*/_jsx(Input.Search, {
    withSuffixIcon: true,
    style: {
      width: 200
    },
    value: v,
    onChange: handleChange,
    ...props
  });
};
/** 表格组件onChange得值不要是特殊对象。因为参数要可以放到url上 */


export const renderTypes = {
  select: props => {
    return /*#__PURE__*/_jsx(Select, {
      allowClear: true,
      style: {
        width: 200
      },
      ...props,
      options: props.options || []
    });
  },
  refresh: (_, {
    refresh
  }) => {
    return /*#__PURE__*/_jsx(ActionButton, {
      action: "refresh",
      onClick: refresh
    });
  },
  customColumns: (_, {
    columnsIn
  }) => {
    return /*#__PURE__*/_jsx(CustomerColumns, {
      columnsIn: columnsIn
    });
  },
  datePicker: ({
    onChange: onChangeIn,
    value,
    ...props
  }) => {
    const onChange = value => {
      onChangeIn && onChangeIn(value ? new Date(value.format()).getTime() : undefined);
    };

    return /*#__PURE__*/_jsx(DatePicker // eslint-disable-next-line react/jsx-no-bind
    , {
      onChange: onChange,
      style: {
        width: 200,
        ...(props.style || {})
      },
      value: value && moment(value),
      ...props
    });
  },
  dateRangePicker: ({
    onChange: onChangeIn,
    value,
    ...props
  }) => {
    var _value$filter;

    const onChange = value => {
      onChangeIn && onChangeIn(value === null || value === void 0 ? void 0 : value.map(i => new Date(i.format()).getTime()));
    };

    return /*#__PURE__*/_jsx(RangePicker, { ...props,
      // eslint-disable-next-line react/jsx-no-bind
      onChange: onChange,
      value: value === null || value === void 0 ? void 0 : (_value$filter = value.filter(i => i)) === null || _value$filter === void 0 ? void 0 : _value$filter.map(i => moment(Number(i)))
    });
  },
  create: ({
    onClick: onClickIn,
    text,
    children,
    ...props
  }, {
    history
  }) => {
    const onClick = e => {
      const link = props.href || props.to;

      if (link) {
        if (link.startsWith('http')) {
          window.open(link, '_blank');
        }

        history.push(link);
      }

      if (onClickIn) {
        return onClickIn(e);
      }
    };

    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-no-bind
      _jsx(ActionButton, {
        type: "primary",
        action: "create",
        onClick: onClick,
        ...props,
        children: text || children
      })
    );
  },
  input: props => {
    return /*#__PURE__*/_jsx(Input, {
      style: {
        width: 200
      },
      allowClear: true,
      ...props
    });
  },
  search: ({
    onChange,
    ...props
  }) => {
    return /*#__PURE__*/_jsx(Search, {
      allowClear: true,
      withSuffixIcon: true,
      style: {
        width: 200
      },
      onSearch: onChange,
      ...props
    });
  },
  groupInput: ({
    options,
    selectProps,
    ...props
  }) => {
    return /*#__PURE__*/_jsx(GroupInput, {
      options: options || [],
      selectProps: {
        style: {
          width: 100
        },
        ...selectProps
      },
      style: {
        width: 300
      },
      ...props
    });
  },
  groupSearch: ({
    options,
    selectProps,
    onChange,
    ...props
  }) => {
    return /*#__PURE__*/_jsx(GroupInput.GroupSearch, {
      allowClear: true,
      options: options || [],
      selectProps: {
        style: {
          width: 100
        },
        ...selectProps
      },
      style: {
        width: 300
      },
      onSearch: onChange,
      ...props
    });
  }
};
export const columnRenderTypes = {
  stateTag: (value, record, index, {
    column
  }) => {
    const filters = column.filters || [];
    const optionObject = filters.reduce((total, filter) => ({ ...total,
      [filter.value]: filter
    }), {});
    const current = optionObject[value] || {};
    return /*#__PURE__*/_jsx(StateTag, {
      type: current.state,
      children: current.text || '-'
    });
  },
  date: value => /*#__PURE__*/_jsx(DateTime, {
    value: value,
    showDate: true,
    showTime: false
  }),
  time: value => /*#__PURE__*/_jsx(DateTime, {
    value: value,
    showDate: false,
    showTime: true
  }),
  dateTime: value => /*#__PURE__*/_jsx(DateTime, {
    value: value,
    showDate: true,
    showTime: true
  }),
  text: (value, record, index, {
    column
  }) => /*#__PURE__*/_jsx(Text, {
    value: value,
    tooltip: column.tooltip,
    ellipsis: column.ellipsis,
    copyable: column.copyable
  }),
  enum: (value, record, index, {
    column
  }) => {
    const calcValue = (column.filters || []).find(v => v.value === value);
    return /*#__PURE__*/_jsx(Text, {
      value: calcValue === null || calcValue === void 0 ? void 0 : calcValue.text,
      tooltip: column.tooltip,
      ellipsis: column.ellipsis,
      copyable: column.copyable
    });
  }
};
export const columnFilterTypes = {
  single: record => ({ ...record,
    filterMultiple: false
  }),
  multiple: record => ({ ...record,
    filterMultiple: true
  })
};
//# sourceMappingURL=es/config.js.map